<template>
  <div class="captcha-box text-white text-center">
    <p class="mb-2 terminal-title">
      <i class="fas fa-robot me-2 text-primary"></i>{{ $t('captcha.instruction') }}
    </p>

    <div class="grid">
      <button
        v-for="(cell, index) in board"
        :key="index"
        class="cell"
        :disabled="cell !== '' || gameOver"
        @click="handleClick(index)"
      >
        {{ cell }}
      </button>
    </div>

    <div v-if="gameOver && passed" class="mt-3 result-msg text-primary">
      {{ $t('captcha.success') }}
    </div>
    <div v-if="gameOver && !passed" class="mt-3 result-msg text-danger">
      {{ $t('captcha.fail') }}
    </div>


    <button
  v-if="gameOver"
  class="btn btn-outline-primary mt-3"
  @click="resetGame"
>
  <i class="fas fa-rotate-left me-1"></i> {{ $t('captcha.retry') }}
</button>

  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue'

const emit = defineEmits(['update:modelValue'])

const board = ref(Array(9).fill(''))
const passed = ref(false)
const gameOver = ref(false)
const attempts = ref(0)

const winningCombos = [
  [0, 1, 2], [3, 4, 5], [6, 7, 8], // rows
  [0, 3, 6], [1, 4, 7], [2, 5, 8], // cols
  [0, 4, 8], [2, 4, 6]             // diagonals
]

const checkWin = (symbol) => {
  return winningCombos.some(([a, b, c]) =>
    board.value[a] === symbol &&
    board.value[b] === symbol &&
    board.value[c] === symbol
  )
}
const resetGame = () => {
  board.value = Array(9).fill('')
  passed.value = false
  gameOver.value = false
  // attempts.value = 0 ← poți șterge complet dacă nu-l mai folosești
}

const handleClick = (index) => {
  if (board.value[index] !== '' || gameOver.value) return

  board.value[index] = 'X'

  if (checkWin('X')) {
    gameOver.value = true
    passed.value = true
    emit('update:modelValue', true)
    return
  }

  attempts.value++

  // Mutare bot simplă (O) după delay
setTimeout(() => {
  if (gameOver.value) return

  const emptyIndices = board.value
    .map((cell, i) => (cell === '' ? i : null))
    .filter(i => i !== null)

  if (emptyIndices.length === 0) {
    // Tabla e plină, nimeni n-a câștigat = fail
    gameOver.value = true
    passed.value = false
    emit('update:modelValue', false)
    return
  }

  const move = emptyIndices[Math.floor(Math.random() * emptyIndices.length)]
  board.value[move] = 'O'

  if (checkWin('O')) {
    gameOver.value = true
    passed.value = false
    emit('update:modelValue', false)
    return
  }

  // După mutarea O, dacă tabla e plină din nou
  const stillEmpty = board.value.some(cell => cell === '')
  if (!stillEmpty && !checkWin('X')) {
    gameOver.value = true
    passed.value = false
    emit('update:modelValue', false)
  }
}, 300)


}
</script>

<style scoped>
.captcha-box {
  background-color: rgba(0, 0, 0, 0.5);
  border: 2px solid #00ffcc88;
  padding: 1.2rem;
  border-radius: 12px;
  font-family: 'Fira Code', monospace;
  max-width: 400px;
  margin: 0 auto;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 10px auto;
  max-width: 200px;
}
.text-primary {
  color: #00ffcc !important;
}
.btn-outline-primary {
  position: relative;
  color: #00ffcc !important;
  border: 2px solid #00ffcc;
  background-color: transparent;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 0 8px transparent;
}

.btn-outline-primary:hover {
  color: #fff !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}
.btn-outline-primary:disabled {
  color: #fff !important;
  border-color: #00a584;
  transform: translateY(-2px);
}
.cell {
  background-color: #111;
  border: 2px solid #00ffcc44;
  color: #00ffcc;
  font-weight: bold;
  font-size: 1.5rem;
  width: 60px;
  height: 60px;
  transition: all 0.2s ease;
  cursor: pointer;
}
.cell:hover:enabled {
  background-color: #00ffcc22;
  box-shadow: 0 0 8px #00ffcc55;
}
.cell:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.result-msg {
  font-size: 0.95rem;
}
</style>
